export default __webpack_public_path__ + "static/foodImage-bea96953ae33fa132f9fbdbe2524a114.webp";